export default "__VITE_ASSET__CttHRnRD__"